import { Component, OnInit, Input } from '@angular/core';
import { Router } from '@angular/router';
import { FileItem, FileLikeObject, FileUploader, FileUploaderOptions } from 'ng2-file-upload';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { NgxSpinnerService } from 'ngx-spinner';
import * as Constants from '../../models/Constants';
import { AccountService } from '../../services/account.service';
import { AlertService } from '../../shared/services/alert.service';
import {ProductCategory, Inspection, InspectionStatuses, InspectionStatus } from '../shared/models/Inspection';
import { InspectionService } from '../shared/services/inspection.service';
import { SubDataVariables } from '../../../environments/app.variables';
import { ErrorHandlerService } from '../../services/error-handler.service';
import { BsDatepickerConfig } from 'ngx-bootstrap/datepicker';
import { Document } from '../../models/ApplicationModel';
import {
  formatDisallowedTypeMessage,
  parseUploadApiError,
  PDF_FILE_TOO_LARGE_MESSAGE,
  validatePdfFileBeforeUpload
} from '../../shared/helpers/pdf-upload-validator';

@Component({
  selector: 'inspection-change-status',
  templateUrl: './change-status.component.html',
  styleUrls: ['./change-status.component.css']
})
export class ChangeStatusComponent implements OnInit {

  @Input() docs: Array<Document>;
  @Input() isPartialApprovalRecommended: boolean;
  @Input() isPartialApprovalLetterGenerated: boolean;
  @Input() isCapaRecommend: boolean;
  @Input() isInspectionReportSubmitted: boolean;
  @Input() hasPartialApprovalRecommend: boolean;

  @Input() inspection: Inspection;
  @Input() newStatusCode: string;
  @Input() showInspectionActions: boolean;
  @Input() isGMP: boolean;

  public title : string;
  public buttonLabel : string;
  public comment: string;
  public constants: any = Constants;
  public docUploading = false;
  public uploadedDoc: Document;
  public docUploader: FileUploader;
  public uploaderOptions: FileUploaderOptions = {
    'allowedFileType': ['pdf'],
    'maxFileSize': 6 * 1024 * 1024,
    'headers': [{
      name: 'Authorization',
      value: 'Bearer ' + this.accountService.getTokenData()
    }],
    'url': SubDataVariables.INSPECTION_DOC_URL
  };
  public minDate: Date = new Date();
  public maxDate: Date;
  public  minDateDue: Date | null = null;
  public datepicker: Date;

  public datepickerStartDate: Date;
  public datepickerDueDate: Date;

  public bsValue: Date = new Date();
  public bsConfig: Partial<BsDatepickerConfig>;
  public showSuspensionExpiryDate: boolean = false;
  public showCapaDueDate: boolean = false;
  public showActualDate: boolean = false;
  public showImplementationReportDueDate: boolean = false;
  public showProductionLines: boolean = false;
  public isCapaProductionLines: boolean = false;
  public isExemptedProductionLines: boolean = false;
  public showCertificateExpiryDate: boolean = false;
  public commentTitle = 'Comment';
  public prodLineData: ProductCategory[] = [];
  public approvedProductionLines: number[] = [];
  public uploadDocTitle = "Upload Inspection Result";
  public showGmpDocUploadActions = false;
  public taskForceDocUploadActions = false;
  public taskForceReportUploaded = false;
  public showCAPARequestUploadActions = false;
  public showDisagreementUploadActions = false; 
  public disagreementUploaded = false; 
  public reviewMinuteSharedUploaded = false;
  public CAPAPlanOrImplementationEvidenceUploaded = false;
  public ImplementationEvidenceReportUploaded = false;
  public showReviewMinuteShared = false;
  public capaRequestUploaded = false;
  public showCAPAAndOrImplementationUploadActions = false;
  public showImplementationEvidenceReport = false;
  public productionLineTitle="Please select the production lines to approve:";
  public nonExemptedDetails = [];
  public exemptedDetails = [];


  constructor(private alertService: AlertService, private spinner: NgxSpinnerService, private inspectionService: InspectionService,
    private router: Router, public modalRef: BsModalRef, private accountService: AccountService,
    private errorHandlerService: ErrorHandlerService) { }

  ngOnInit() {
    this.setStatusChangeValues();
      

    this.showGmpDocUploadActions = [InspectionStatuses.GMP_CANCELLED, InspectionStatuses.GMP_SUSPENDED, InspectionStatuses.GMP_REVOKED].indexOf(this.newStatusCode) !== -1;

   // this.taskForceDocUploadActions = [InspectionStatuses.PASSED_TASK_FORCE_ASSESMENT, InspectionStatuses.FAILED_TASK_FORCE_ASSESMENT].indexOf(this.newStatusCode) !== -1;
   
    this.showCAPARequestUploadActions = [InspectionStatuses.CAPA_PLAN_REQUESTED].indexOf(this.newStatusCode) !== -1;
     this.showDisagreementUploadActions = [InspectionStatuses.DISAGREEMENT_NOTIFIED].indexOf(this.newStatusCode) !== -1;
     this.showReviewMinuteShared = [InspectionStatuses.REVIEW_MINUTE_SHARED].indexOf(this.newStatusCode) !== -1;
   this.showCAPAAndOrImplementationUploadActions = [InspectionStatuses.RECOMMEND_FOR_APPROVAL_AFTER_INSPECTION,InspectionStatuses.RECOMMEND_FOR_CORRECTION].indexOf(this.newStatusCode) !== -1;
    this.showImplementationEvidenceReport = [InspectionStatuses.RECOMMENDED_FOR_APPROVAL_AFTER_IMPLEMENTATION_EVIDENCE
      ,InspectionStatuses.RECOMMENDED_FOR_PARTIAL_APPROVAL_AFTER_IMPLEMENTATION_EVIDENCE, InspectionStatuses.RECOMMENDED_FOR_REJECTION_AFTER_IMPLEMENTATION_EVIDENCE].indexOf(this.newStatusCode) !== -1;
    if (this.showInspectionActions || this.showGmpDocUploadActions || this.taskForceDocUploadActions 
      || this.showCAPARequestUploadActions || this.showDisagreementUploadActions ||this.showCAPAAndOrImplementationUploadActions
      || this.showReviewMinuteShared|| this.showImplementationEvidenceReport) {
      this.setupDocUploader();
    }
    this.datepicker = null;
    this.datepickerStartDate = null;
    this.datepickerDueDate = null;
    console.log(this.newStatusCode);
    if([InspectionStatuses.LICENSE_SUSPENDED_CODE, InspectionStatuses.GMP_SUSPENDED ].indexOf(this.newStatusCode) != -1){
      this.showSuspensionExpiryDate = true;  
    }
    if([InspectionStatuses.CAPA_PLAN_REQUESTED, InspectionStatuses.CAPA_PLAN_REJECTED ].indexOf(this.newStatusCode) != -1){
      this.showCapaDueDate = true;  
    }
    if([InspectionStatuses.IMPLEMENTATION_REPORT_REQUESTED, InspectionStatuses.IMPLEMENTATION_REPORT_REJECTED ].indexOf(this.newStatusCode) != -1){
      this.showImplementationReportDueDate = true;  
    }
       if(([InspectionStatuses.RECOMMEND_FOR_APPROVAL_CODE, InspectionStatuses.RECOMMEND_FOR_REJECTION_CODE, InspectionStatuses.CAPA_PLAN_RECOMMEND , InspectionStatuses.PARTIAL_APPROVAL_RECOMMENDED
        ,InspectionStatuses.RECOMMENDED_FOR_APPROVAL_AFTER_IMPLEMENTATION_EVIDENCE, 
        InspectionStatuses.RECOMMENDED_FOR_REJECTION_AFTER_IMPLEMENTATION_EVIDENCE,
        InspectionStatuses.RECOMMENDED_FOR_PARTIAL_APPROVAL_AFTER_IMPLEMENTATION_EVIDENCE
       ].indexOf(this.newStatusCode) != -1) &&(this.inspection.inspectionAssignments
        .every(a => a.actualStartDate === null && a.actualDueDate === null)))
       {  
      this.showActualDate = true;  
    }

    if(this.isPartialApprovalRecommended || this.isCapaRecommend || this.isInspectionReportSubmitted 
      ||(this.isPartialApprovalLetterGenerated && !this.hasPartialApprovalRecommend)){  
      this.nonExemptedDetails =  this.inspection.productionInfo.productDetails;
      this.isCapaProductionLines = this.isCapaRecommend;
      this.isExemptedProductionLines = this.isInspectionReportSubmitted;
      this.showProductionLines = true;
      if(this.isCapaProductionLines){
        this.productionLineTitle ="Select the Production line with deficiency";
      }
      else if(this.isExemptedProductionLines){
        this.productionLineTitle = "Select the Production line to exempt from inspection";
      }
      else{
 this.productionLineTitle = "Select the Production line to approve";
      }
       

        if (!this.isExemptedProductionLines) {
             const prodLines = this.inspection?.productionInfo?.['prodInfoProdLines'] || []; 

  this.nonExemptedDetails =
  this.inspection.productionInfo.productDetails
    .filter(prod => {
      const match = prodLines.find(
        line => line.productionLine?.id === prod.productionLine?.id
      );
      return match?.isExempted === false;
    });



  }
      this.refreshExemptedDetails();
    } 

    if(this.showCertificateExpiryDate){
      this.maxDate = new Date();
      this.maxDate.setFullYear(this.maxDate.getFullYear() + 3);
    }
    if(this.showActualDate){
        const today = new Date();
 
     this.maxDate = new Date(today);
     this.maxDate.setDate(today.getDate()); 

    this.minDate = new Date(today.getFullYear() - 5, 0, 1); 
    }
    
  }
onStartDateChange() {
  // Clear any existing due date when start date changes
  this.datepickerDueDate = null;

  if (this.datepickerStartDate) {
    const start = new Date(this.datepickerStartDate);
    const max = new Date(this.maxDate);

    // Strip time portion for both dates
    start.setHours(0, 0, 0, 0);
    max.setHours(0, 0, 0, 0);

    // Set minDateDue to start date if it's before or equal to max (yesterday)
    this.minDateDue = (start <= max) ? start : max;
  } else {
    // fallback if start date is not selected
    this.minDateDue = this.minDate;
  }
}


  approveProductionLine(productionLineID){
    const id = Number(productionLineID);
    if (!Number.isFinite(id)) {
      return;
    }
    if(this.approvedProductionLines.some(apl => apl === id)){
      this.approvedProductionLines = this.approvedProductionLines.filter(apl => apl !== id);
    }else{
      this.approvedProductionLines = [...this.approvedProductionLines, id];
    }
    this.refreshExemptedDetails();
  }

  isProductionLineApproved(productionLineID: number): boolean {
    return this.approvedProductionLines.some(apl => apl === Number(productionLineID));
  }

  private refreshExemptedDetails() {
    if (!this.isExemptedProductionLines || !this.nonExemptedDetails?.length) {
      this.exemptedDetails = [];
      return;
    }
    const selected = new Set(this.approvedProductionLines);
    this.exemptedDetails = this.nonExemptedDetails.filter(prod =>
      selected.has(Number(prod.productionLine?.id))
    );
  }


  setStatusChangeValues(){
    switch(this.newStatusCode){
      case InspectionStatuses.INSPECTED_CODE:
        this.title = 'Recommend for Inspection Pass';
        this.buttonLabel = Constants.PASS;
        break;
      case InspectionStatuses.INSPECTION_FAILED_CODE:
        this.title = 'Recommend for Inspection Fail';
        this.buttonLabel = Constants.FAIL;
        break;
      case InspectionStatuses.RECOMMEND_FOR_APPROVAL_CODE:
      case InspectionStatuses.RECOMMENDED_FOR_APPROVAL_AFTER_IMPLEMENTATION_EVIDENCE:
        this.title = 'Recommend for Compliance';
        this.buttonLabel = Constants.PASS;
        break;
      case InspectionStatuses.RECOMMEND_FOR_REJECTION_CODE:
      case InspectionStatuses.RECOMMENDED_FOR_REJECTION_AFTER_IMPLEMENTATION_EVIDENCE:
        this.title = 'Recommend for Non-Compliance';
        this.buttonLabel = Constants.FAIL;
        break;
      case InspectionStatuses.RETURN_TO_INSPECTOR_CODE:
        this.title = 'Return to Inspector';
        this.buttonLabel = Constants.RETURN;
        break;
      case InspectionStatuses.RETURN_REPORT_TO_INSPECTOR:
        this.title = 'Return Report to Inspector';
        this.buttonLabel = Constants.RETURN;
        break;
      case InspectionStatuses.APPROVAL_LETTER_GENERATED_CODE:
        this.buttonLabel = Constants.GENERATE;
        if(this.isGMP){
          this.title = 'Generate cGMP certificate';
          this.showCertificateExpiryDate = true;  
        } else {
          this.title = 'Generate Approval Letter';
        }
        break;
      case InspectionStatuses.PARTIAL_APPROVAL_LETTER_GENERATED_CODE:
        this.title = 'Generate Partial cGMP certificate';
        this.buttonLabel = Constants.GENERATE;
        if(this.isGMP){
          this.showCertificateExpiryDate = true;  
        }
        break;
      case InspectionStatuses.PRODUCT_RECALLED_CODE:
        this.title = 'Generate Product Recall Letter';
        this.buttonLabel = Constants.GENERATE;
        break;
      case InspectionStatuses.LICENSE_CANCELLED_CODE:
        this.title = 'Generate License Cancellation Letter';
        this.buttonLabel = Constants.GENERATE;
        break;
      case InspectionStatuses.LICENSE_SUSPENDED_CODE:
        this.title = 'Generate License Suspension Letter';
        this.buttonLabel = Constants.GENERATE;
        break;
      case InspectionStatuses.WARNING_GIVEN_CODE:
        this.title = 'Generate Warning Letter';
        this.buttonLabel = Constants.GENERATE;
        break;
      case InspectionStatuses.FORWARDED_FOR_FOLLOW_UP_INSPECTION:
        this.title = 'Forward for Follow up Inspection';
        this.buttonLabel = Constants.PASS;
        break;
      case InspectionStatuses.RETURN_TO_APPLICANT:
        this.title = 'Return to Applicant';
        this.buttonLabel = Constants.RETURN;
        break;
      case InspectionStatuses.SCREENING_PASSED:
        this.title = 'Pass Screening';
        this.buttonLabel = Constants.PASS;
        break;
      case InspectionStatuses.SCREENING_FAILED:
        this.title = 'Fail Prescreening';
        this.buttonLabel = Constants.FAIL;
        this.commentTitle = "Deficiency List";
        break;
      case InspectionStatuses.PAYMENT_REQUEST_LETTER_GENERATED:
        this.title = 'Generate Payment Request Letter';
        this.buttonLabel = Constants.PASS;
        break;
      case InspectionStatuses.RETURNED_TO_APPLICANT_TO_COMPLETE_APPLICATION:
        this.title = 'Return to Applicant to Complete Application';
        this.buttonLabel = Constants.FAIL;
        this.commentTitle = "Deficiency List";
        break;
      case InspectionStatuses.RECOMMEND_FOR_PAYMENT_APPROVAL:
        this.title = 'Recommend for Payment Approval';
        this.buttonLabel = Constants.PASS;
        break;
      case InspectionStatuses.RECOMMEND_FOR_PAYMENT_FAILURE:
        this.title = 'Recommend for Payment Failure';
        this.buttonLabel = Constants.FAIL;
        break;
      case InspectionStatuses.NON_COMPLIANCE_LETTER_GENERATED:
        this.title = 'Generate Non-Compliance Letter';
        this.buttonLabel = Constants.GENERATE;
        break;
      case InspectionStatuses.APPROVAL_LETTER_GENERATED_WITH_CAPA:
        this.title = 'Generate Approval Letter with CAPA';
        this.buttonLabel = Constants.GENERATE;
        break;
      case InspectionStatuses.WITHDRAWN:
        this.title = 'Withdraw Application';
        this.buttonLabel = Constants.WITHDRAW;
        break;
      case InspectionStatuses.RETURN_TO_INSPECTION_TEAM_LEADER_CODE:
        this.title = 'Return to Desk Head';
        this.buttonLabel = Constants.RETURN;
        break;
      case InspectionStatuses.ASSIGNED_TO_INSPECTOR:// when undoing withdraw for post licensing
        this.title = 'Undo Withdraw';
        this.buttonLabel = Constants.UNDO_WITHDRAW_LABEL;
        break;
      case InspectionStatuses.REJECTED:
        this.title = 'Reject';
        this.buttonLabel = Constants.FAIL;
        break;
      case InspectionStatuses.GMP_CANCELLED:
        this.title = 'Cancel GMP';
        this.buttonLabel = Constants.CANCEL;
        break;
      case InspectionStatuses.GMP_SUSPENDED:
        this.title = 'Suspend GMP';
        this.buttonLabel = Constants.SUSPEND;
        break;
      case InspectionStatuses.GMP_REVOKED:
        this.title = 'Revoke GMP';
        this.buttonLabel = Constants.REVOKE;
        break;
      case InspectionStatuses.GMP_VOID:
        this.title = 'Void GMP';
        this.buttonLabel = Constants.VOID;
        break;
      case InspectionStatuses.FINAL_FILE_SUBMITTED_CODE:
        this.title = 'Submit Final File for Preparation';
        this.buttonLabel = Constants.PASS;
        break;
      case InspectionStatuses.APPROVED_FOR_INSPECTION_CODE:
        this.title = 'Approve For Inspection';
        this.buttonLabel = Constants.PASS;
        break;
      case InspectionStatuses.RETURNED_TO_FILE_SUBMISSION_CODE:
        this.title = 'Return to Inspector for Final File Submission';
        this.buttonLabel = Constants.RETURN;
        break;
      case InspectionStatuses.RECOMMEND_FOR_SCREENING_PASS:
        this.title = 'Recommend for Payment';
        this.buttonLabel = Constants.RECOMMEND;
        break;
      case InspectionStatuses.RECOMMEND_FOR_SCREENING_FAIL:
        this.title = 'Recommend to Return to Applicant';
        this.buttonLabel = Constants.RECOMMEND;
        break;
      case InspectionStatuses.FINAL_PAYMENT_REQUESTED:
        this.title = 'Request Final Payment';
        this.buttonLabel = Constants.REQUEST;
        break;
     case InspectionStatuses.FINAL_PAYMENT_RETURNED:
        this.title = 'Return Final Payment';
        this.buttonLabel = Constants.RETURN;
        break;
      case InspectionStatuses.CAPA_PLAN_REQUESTED:
          this.title = 'Request CAPA Plan';
          this.buttonLabel = Constants.REQUEST;
          break;
      case InspectionStatuses.CAPA_PLAN_REJECTED:
          this.title = 'Reject CAPA Plan';
          this.buttonLabel = Constants.FAIL;
          break;
      case InspectionStatuses.IMPLEMENTATION_REPORT_REQUESTED:
          this.title = 'Request Implementation Evidence';
          this.buttonLabel = Constants.REQUEST;
          break;
      case InspectionStatuses.IMPLEMENTATION_REPORT_REJECTED:
          this.title = 'Reject Implementation Evidence';
          this.buttonLabel = Constants.FAIL;
          break;      
      case InspectionStatuses.PAYMENT_APPROVED:
          this.title = 'Approve Payment';
          this.buttonLabel = Constants.APPROVE;
          break;   
      case InspectionStatuses.PAYMENT_RETURNED_TO_COORDINATOR:
          this.title = 'Return Payment';
          this.buttonLabel = Constants.RETURN;
          break;   
      case InspectionStatuses.PASSED_TASK_FORCE_ASSESMENT:
          this.title = 'Pass Task Force Assessment';
          this.buttonLabel = Constants.PASS;
          break;   
      case InspectionStatuses.FAILED_TASK_FORCE_ASSESMENT:
          this.title = 'Recommend For Fail';
          this.buttonLabel = Constants.RETURN;
          break;   
      case InspectionStatuses.FIR_REQUESTED_BEFORE_INSPECTION:
      case InspectionStatuses.FIR_REQUESTED_AFTER_INSPECTION:  
        this.title = 'Request FIR';
        this.buttonLabel = Constants.REQUEST;
        break;       
      case InspectionStatuses.RETURNED_TO_GMP_OFFICER:  
        this.title = 'Return to Inspector(For Application Screen)';
        this.buttonLabel = Constants.RETURN;
        break;      
        case InspectionStatuses.CAPA_PLAN_RECOMMEND:
          this.title = 'Recommend for CAPA';
          this.buttonLabel = Constants.RECOMMEND;
          break;    
       case InspectionStatuses.PARTIAL_APPROVAL_RECOMMENDED:
       case InspectionStatuses.RECOMMENDED_FOR_PARTIAL_APPROVAL_AFTER_IMPLEMENTATION_EVIDENCE:
          this.title = 'Recommend for Partial Approval';
          this.buttonLabel = Constants.RECOMMEND;
          break;   
       case InspectionStatuses.SUBMIT_FOR_APPROVAL:
          this.title = 'Submit for Approval';
          this.buttonLabel = Constants.SUBMITAPP;
          break;    
        case InspectionStatuses.PARTIAL_APPROVAL_SUBMITTED:
          this.title = 'Submit for Partial Approval';
          this.buttonLabel = Constants.SUBMITAPP;
          break;   

 
           case InspectionStatuses.TENTATIVE_PLAN_APPROVED:
          this.title = 'Approve Tentative Plan';
          this.buttonLabel = Constants.APPROVE;
          break;  
             case InspectionStatuses.TENTATIVE_PLAN_RETURNED:
          this.title = 'Return Tentative Plan';
          this.buttonLabel = Constants.RETURN;
          break;  
             case InspectionStatuses.TENTATIVE_PLAN_SHARED:
          this.title = 'Share Tentative Plan';
          this.buttonLabel = Constants.PASS;
          break;  
          case InspectionStatuses.AGREEMENT_NOTIFIED:
          this.title = 'Notify Readiness';
          this.buttonLabel = Constants.NOTIFY;
          break;
          case InspectionStatuses.DISAGREEMENT_NOTIFIED:
          this.title = 'Notify Unreadiness';
          this.buttonLabel = Constants.NOTIFY;
          break;  
          case InspectionStatuses.INSPECTION_REPORT_SUBMITED:
          this.title = 'Submit Inspection Report';
          this.buttonLabel = Constants.SUBMITPASS;
          break;  
          case InspectionStatuses.APPLICATION_CLOSED:
          this.title = 'Close Application';
          this.buttonLabel = Constants.CLOSE;
          break;
          case InspectionStatuses.REVIEW_MINUTE_SHARED:
          this.title = 'Share Review Minute';
          this.buttonLabel = Constants.PASS;
          break;  
          case InspectionStatuses.TASK_FORCE_REVIEW_REPORT_UPDATED:
          this.title = 'Update Inspection Report';
          this.buttonLabel = Constants.SUBMITPASS;
          break;   
          
         case InspectionStatuses.REQUEST_FOR_REJECTION:
          this.title = 'Submit For Non-Compliance';
          this.buttonLabel = Constants.SUBMITPASS;
          break;
          case InspectionStatuses.CAPA_PLAN_AND_IMPLEMENTATION_EVIDENCE_SUBMITTED:
          this.title = 'Submit CAPA Plan and Implementation Evidence';
          this.buttonLabel = Constants.SUBMITAPP;
          break;  
          case InspectionStatuses.PAYMENT_RETURNED_TO_APPLICANT:
          this.title = 'Return Payment to Applicant';
          this.buttonLabel = Constants.SUBMITAPP;
          break; 

          case InspectionStatuses.ASSIGNED_TO_INSPECTOR_FOR_TENTATIVE_PLAN:
          this.title = 'Assign Tentative Plan to Inspector';
          this.buttonLabel = Constants.SUBMITAPP;
          break;
          case InspectionStatuses.TENTATIVE_PLAN_SUBMIT:
          this.title = 'Submit Tentative Plan';
          this.buttonLabel = Constants.SUBMITPASS;
          break;  
          case InspectionStatuses.ASSIGNED_TO_INSPECTOR_AFTER_INSPECTION:
          case InspectionStatuses.ASSIGNED_TO_INSPECTOR_AFTER_IMPLEMENTATION_EVIDENCE :
          this.title = 'Assign Inspection Report to Inspector';
          this.buttonLabel = Constants.SUBMITAPP;
          break; 

          case InspectionStatuses.FINAL_PAYMENT_APPROVED :
          this.title = 'Approve Final Payment';
          this.buttonLabel = Constants.APPROVE;
          break;
          case InspectionStatuses.RECOMMEND_FOR_APPROVAL_AFTER_INSPECTION:
          this.title = 'Recommend for Approval for CAPA and/or Evidence';
          this.buttonLabel = Constants.RECOMMEND;
          break;  
          case InspectionStatuses.RECOMMEND_FOR_CORRECTION:
          case InspectionStatuses.RECOMMENDED_FOR_CORRECTION_AFTER_IMPLEMENTATION_EVIDENCE:
          this.title = 'Recommend for Correction';
          this.buttonLabel = Constants.RECOMMEND;
          break; 

          case InspectionStatuses.FINAL_PAYMENT_APPROVED :
          this.title = 'Approve Final Payment';
          this.buttonLabel = Constants.SUBMITAPP;
          break;
          case InspectionStatuses.RETURN_TO_INSPECTOR_AFTER_INSPECTION:
          this.title = 'Return to Inspector After Inspection';
          this.buttonLabel = Constants.RETURN;
          break;  
          case InspectionStatuses.RETURN_FOR_CORRECTION :
          this.title = 'Return for Correction';
          this.buttonLabel = Constants.RETURN;
          break; 

          case InspectionStatuses.RECOMMENDED_FOR_SITE_INSPECTION :
          this.title = 'Recommend for Site Inspection';
          this.buttonLabel = Constants.RECOMMEND;
          break; 
          case InspectionStatuses.SITE_INSPECTION_REPORT_SUBMITTED :
          this.title = 'Submit Recommendation For Site Inspection';
          this.buttonLabel = Constants.SUBMITPASS;
          break; 
          case InspectionStatuses.RETURNED_TO_DESK_HEAD_FOR_REVIEW :
          this.title = 'Return to Desk Head for Review';
          this.buttonLabel = Constants.RETURN;
          break; 
  
    }
  }

  submitForm(){
    this.spinner.show();
    // handle non-gmp such as post licensing inspection doc upload separtely 
    if((!this.isGMP || this.showGmpDocUploadActions || this.taskForceDocUploadActions || this.showDisagreementUploadActions) && this.uploadedDoc != null) {
      this.docs = [this.uploadedDoc];
    }
    if(this.isGMP && this.showReviewMinuteShared){
      this.docs = [this.uploadedDoc]
    }
    const data = {
      'inspectionID': this.inspection.id,
      'statusCode': this.newStatusCode,
      'comment': this.comment,
      'certificateExpiryDate': this.datepicker,
      'documents': this.docs,
      'suspensionExpiryDate': this.datepicker,
      'approvedProductionLines': this.approvedProductionLines,
      'capaDueDate': this.datepicker,
      'implementationReportDueDate': this.datepicker,
      'actualStartDate': this.datepickerStartDate,
      'actualDueDate': this.datepickerDueDate,
    };

    this.inspectionService.changeInspectionStatus(data).subscribe(
      response => {
        this.spinner.hide();
        this.modalRef.hide();
        if (response) {
          if (this.buttonLabel == this.constants.GENERATE) {
            const printLabel = this.showCertificateExpiryDate ? 'certificate' : 'document';
            this.alertService.success(`Inspection status changed successfully. Wait 30 seconds to print the ${printLabel}.`);
          } else {
            this.alertService.success('Inspection Status Changed Successfully');
          }
          this.router.navigate([this.inspectionService.getInspectionListUrl(this.inspection)]);
        } else {
          this.alertService.error('Inspection Status Change Failed');
        }
      }, err => {
        this.spinner.hide();
        this.modalRef.hide();
        this.alertService.error(this.errorHandlerService.handleApiError(err));
        console.log(err);
    });

  }

  setupDocUploader(){
    this.docUploader = new FileUploader(this.uploaderOptions);
    let uploadErrorMessage = "";
    this.docUploader.onWhenAddingFileFailed = (item: FileLikeObject, filter: any, options: any) => {
      this.modalRef.hide();
      switch (filter.name) {
        case 'fileSize':
          uploadErrorMessage = PDF_FILE_TOO_LARGE_MESSAGE;
          break;
        case 'fileType':
          uploadErrorMessage = formatDisallowedTypeMessage(item.type || 'unknown');
          break;
        default:
          uploadErrorMessage = `Unknown error (filter is ${filter.name})`;
      }
      this.alertService.error(uploadErrorMessage);
    };

    //TODO: change this to be able to upload the docs by name instead of id
    var referenceId = Constants.INSPECTION_RESULT_REFERENCE_ID;
    if(this.newStatusCode == InspectionStatuses.GMP_CANCELLED){
      referenceId = Constants.LICENSE_CANCELLATION_LETTER_REFERENCE_ID;
      this.uploadDocTitle = "Upload Cancellation Letter";
    } else if(this.newStatusCode == InspectionStatuses.GMP_SUSPENDED){
      referenceId = Constants.LICENSE_SUSPENSION_LETTER_REFERENCE_ID;
      this.uploadDocTitle = "Upload Suspension Letter";
    } else if(this.newStatusCode == InspectionStatuses.GMP_REVOKED){
      referenceId = Constants.GMP_REVOCATION_LETTER_ID;
      this.uploadDocTitle = "Upload Revocation Letter";
    } 
    // else if(this.newStatusCode == InspectionStatuses.PASSED_TASK_FORCE_ASSESMENT || this.newStatusCode == InspectionStatuses.FAILED_TASK_FORCE_ASSESMENT){
    //   referenceId = Constants.TASK_FORCE_REPORT_REFERENCE_ID;
    //   this.uploadDocTitle = "Upload Task Force Report";
    // }
     else if(this.newStatusCode == InspectionStatuses.TASK_FORCE_REVIEW_REPORT_UPDATED){
      referenceId = Constants.TASK_FORCE_REPORT_REFERENCE_ID;
      this.uploadDocTitle = "Upload Task Force Report";
    }
        else if(this.newStatusCode == InspectionStatuses.DISAGREEMENT_NOTIFIED){
      referenceId = Constants.NOTIFY_DISAGREEMENT_REFERENCE_ID;
      this.uploadDocTitle = "Upload Reason for Withdrawal or Plan Adjustment";
    }
    else if(this.newStatusCode == InspectionStatuses.CAPA_PLAN_REQUESTED){
      referenceId = Constants.CAPA_PLAN_REQUEST_REFERENCE_ID;
      this.uploadDocTitle = "Upload CAPA plan request letter";
    }
   else if(this.newStatusCode == InspectionStatuses.REVIEW_MINUTE_SHARED){ 
      referenceId = Constants.TASK_FORCE_REVIEW_MINUTE_REFERENCE_ID;
      this.uploadDocTitle = "Upload Review Minute";
    }
      else if(this.newStatusCode == InspectionStatuses.RECOMMEND_FOR_APPROVAL_AFTER_INSPECTION){
      referenceId = Constants.CAPA_PLAN_ANDOR_IMPLEMENTATION_ASSESSEMENT_REPORT_REFERENCE_ID;
      this.uploadDocTitle = "Upload CAPA plan And/Or Implementation Assessement Report";
    }
       else if(this.newStatusCode == InspectionStatuses.RECOMMEND_FOR_CORRECTION){
      referenceId = Constants.CAPA_PLAN_ANDOR_IMPLEMENTATION_ASSESSEMENT_REPORT_REFERENCE_ID;
      this.uploadDocTitle = "Upload CAPA plan And/Or Implementation Assessement Report";
    }
    else if (this.newStatusCode == InspectionStatuses.RECOMMENDED_FOR_APPROVAL_AFTER_IMPLEMENTATION_EVIDENCE
 || this.newStatusCode == InspectionStatuses.RECOMMENDED_FOR_REJECTION_AFTER_IMPLEMENTATION_EVIDENCE
 || this.newStatusCode == InspectionStatuses.RECOMMENDED_FOR_PARTIAL_APPROVAL_AFTER_IMPLEMENTATION_EVIDENCE)
 {
 referenceId = Constants.IMPLEMENTATION_EVIDENCE_ASSESSEMENT_REPORT_REFERENCE_ID;
      this.uploadDocTitle = "Upload Implementation Evidence Assessement Report";
    }

    this.docUploader.onBuildItemForm = (fileItem: any, form: any) => {
      form.append('TempFolderName', this.accountService.getUserData().username);
      form.append('referenceID', referenceId);
      form.append('UserID', this.accountService.getUserData().id);
      form.append('InspectionId', this.inspection.id);
     };

    this.docUploader.onErrorItem = (item: FileItem, response: string, status: number) => {
      this.modalRef.hide();
      this.alertService.error(parseUploadApiError(response, status));
      this.docUploading = false;
    };

    this.docUploader.onAfterAddingFile = (item: FileItem) => {
      item.withCredentials = false;
      validatePdfFileBeforeUpload(item._file, this.uploaderOptions.maxFileSize).then(validationError => {
        if (validationError) {
          this.modalRef.hide();
          this.alertService.error(validationError);
          item.remove();
          return;
        }

        this.docUploading = true;
        this.docUploader.uploadItem(item);
      }).catch(() => {
        this.modalRef.hide();
        this.alertService.error('Unable to read the selected file.');
        item.remove();
      });
    };

    this.docUploader.onCompleteItem = (item: any, response: any, status: any, headers: any) => {
      if (status === 413) {
        this.alertService.error(PDF_FILE_TOO_LARGE_MESSAGE);
      } else if (status === 422) {
        this.alertService.error(parseUploadApiError(response, status));
      } else if (status === 200) {
        response = JSON.parse(response);
        console.log('File upload complete:', item, response);
        this.uploadedDoc = response;
        this.taskForceReportUploaded = response.referenceID === Constants.TASK_FORCE_REPORT_REFERENCE_ID;
        this.disagreementUploaded = response.referenceID === Constants.NOTIFY_DISAGREEMENT_REFERENCE_ID;
        this.CAPAPlanOrImplementationEvidenceUploaded = response.referenceID === Constants.CAPA_PLAN_ANDOR_IMPLEMENTATION_ASSESSEMENT_REPORT_REFERENCE_ID;
        this.reviewMinuteSharedUploaded = response.referenceID === Constants.TASK_FORCE_REVIEW_MINUTE_REFERENCE_ID;
        this.capaRequestUploaded = response.referenceID === Constants.CAPA_PLAN_REQUEST_REFERENCE_ID;
        this.ImplementationEvidenceReportUploaded = response.referenceID === Constants.IMPLEMENTATION_EVIDENCE_ASSESSEMENT_REPORT_REFERENCE_ID;
      }
      this.docUploading = false;
    };
  }

  strokeColor(position): string {
    switch (position) {
      case 'outer':
        return this.buttonLabel === Constants.PASS ? '#1AB394' : '#ED5565';
      case 'inner':
        return this.buttonLabel === Constants.PASS ? '#60e6c4' : '#ff8893';
      default:
        break;
    }
    return '';
  }
}
